import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AccountType } from 'dashboard/models/account-type';
import { AccountTypeGridLayout } from 'dashboard/models/account-type-grid-layouts';
import { AccountVariableDefinition } from 'dashboard/models/account-variable-definition';

export interface State {
  accountType: AccountType | null;
  gridLayouts: AccountTypeGridLayout[];
  accountVariableDefinitions: AccountVariableDefinition[];
}
const initialState: State = {
  accountType: null,
  gridLayouts: [],
  accountVariableDefinitions: [],
};

const { reducer, actions } = createSlice({
  name: 'account-type',
  initialState,
  reducers: {
    setAccountType: (state, action: PayloadAction<AccountType>) => {
      state.accountType = action.payload;
    },
    clearAccountType: (state) => {
      state.accountType = null;
    },
    updateDefaultStatus: (state, action: PayloadAction<AccountType>) => {
      state.accountType = action.payload;
    },
    addAccountTypeGridLayout: (state, action: PayloadAction<AccountTypeGridLayout>) => {
      state.gridLayouts.push(action.payload);
    },
    setAccountTypeGridLayouts: (state, action: PayloadAction<AccountTypeGridLayout[]>) => {
      state.gridLayouts = action.payload;
    },
    setAccountTypeGridLayout: (state, action: PayloadAction<AccountTypeGridLayout>) => {
      const index = state.gridLayouts.findIndex(
        (gridLayout) => gridLayout.id === action.payload.id,
      );

      // this should never happen because we are updating an existing grid layout
      if (index === -1) throw new Error('Account type grid layout not found');

      state.gridLayouts[index] = action.payload;
    },
    setAccountVariableDefinitions: (state, action: PayloadAction<AccountVariableDefinition[]>) => {
      state.accountVariableDefinitions = action.payload;
    },
  },
});

export const {
  setAccountType,
  clearAccountType,
  updateDefaultStatus,
  addAccountTypeGridLayout,
  setAccountTypeGridLayouts,
  setAccountTypeGridLayout,
  setAccountVariableDefinitions,
} = actions;
export const accountTypeReducer = reducer;
